import React, { useEffect, useState, useRef } from 'react';
import { Spinner, Checkbox } from '../Common';


export default class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            password: '',
            errorMessage: '',
            memoryCharged: '0',
            displayPassword: false
        }
    }
    

    onUserNameChange = (e) => {
        const userName = e.target.value;
        this.setState(() => ({ userName }));
    }
    onPasswordChange = (e) => {
        const password = e.target.value;
        this.setState(() => ({ password }));
    }
    toggleDisplayPassword = () => {
        this.setState(prevState => ({ displayPassword: !prevState.displayPassword }));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit({
            userName: this.state.userName,
            password: this.state.password,
            memoryCharged: false
        })
    }

    render() {
        return (
            <div>
                <form id="loginForm" name="login" onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label >Email *</label>
                        <input
                            id="txtUserName"
                            name="username"
                            type="text"
                            className="form-control"
                            //placeholder="Enter email"
                            autoFocus
                            value={this.state.userName}
                            onChange={this.onUserNameChange}
                        />
                    </div>
                    <div className="form-group">
                        <label >Mot de passe *</label>
                        <input
                            id="txtPassword"
                            name="password"
                            type={this.state.displayPassword ? 'text' : 'password'}
                            className="form-control"
                            //placeholder="Password"
                            value={this.state.password}
                            onChange={this.onPasswordChange}
                        />
                        <div className={this.state.displayPassword ? 'icon hidePwd' : 'icon showPwd'} onClick={this.toggleDisplayPassword} ></div>
                    </div>
                    <div className="required-txt"> * Champs obligatoires
                    </div>
                    <div className="button-container float-right login-submit-button">
                        <button id="btnSubmit" name="submit" type="submit" className={`btn btn-primary btn-lg spinner-${this.props.spinner}`} disabled={!this.state.userName || !this.state.password} onClick={this.handleSubmit}>
                            <span>Me connecter</span>
                            <Spinner status={this.props.spinner} />
                        </button>
                    </div>
                </form>
                <div className="missed-password" onClick={this.props.onCLickForgotPassword}>Mot de passe oublié ? </div>
                <div className="bloc-form_error">
                    {this.state.errorMessage &&
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    }
                </div>
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginForm.js